import { BlockBlobClient, BlockBlobParallelUploadOptions } from '@azure/storage-blob'
import { ImportResponse } from '../types/Upload/ImportResponse'
import {
	FilteredRequestsResponse,
	RequestFilters,
	RequestStatus,
	RequestsWorkerResponse,
	RequestWorkItem,
	UpdateRequest,
} from '../types/Work/Request'
import { getAll, patch, postWithResponse, put, processWithConcurrency } from './CommonServices/httpService'
import { ForemanQC } from '../types/Work/ForemanQC'

const getQcInspectionRequests = async (qcId: number) => {
	const res = await getAll<RequestWorkItem[]>(`/Requests/QC/${qcId}`)
	return res.data
}

const updateInspectionRequest = async (
	requestId: number,
	inspectAttachments: Blob[],
	inspectionComment: string,
	IsFinalInspection: boolean,
	status: RequestStatus,
	qcProgress: number | undefined,
	taskType: string
) => {
	const rq: UpdateRequest = {
		requestId: requestId,
		comment: inspectionComment,
		status,
		attachmentCount: inspectAttachments.length,
		IsFinalInspection,
		qcProgress: qcProgress,
		taskType
	}
	const res = await postWithResponse<ImportResponse[]>(`/Requests/Inspection`, rq)

	if (res.data && res.data.length > 0 && inspectAttachments.length === res.data.length) {
		const uploadTasks = inspectAttachments.map((file, index) => {
			// Create a BlobClient for the current file
			const blockBlobClient = new BlockBlobClient(
				`${res.data[index].uploadUri}${res.data[index].sasToken}`,
			)

			const options: BlockBlobParallelUploadOptions = {
				blobHTTPHeaders: { blobContentType: file.type },
			}

			// Upload file
			return () => blockBlobClient.uploadData(file, options)
		})

		await processWithConcurrency(uploadTasks)
	}
	return true
}



const getFilteredRequests = async (filters: RequestFilters) => {
	let url = `/Requests?page=${filters.page}`
	if (filters.requestId != null) url += `&id=${filters.requestId}`

	if (filters.searchWorkItem != '') url += `&workItem=${filters.searchWorkItem}`

	if (filters.assignedToId != null) url += `&assignedToId=${filters.assignedToId}`

	if (filters.requestedById != null) url += `&requestedById=${filters.requestedById}`

	if (filters.inspectedOn != null) url += `&inspectedOn=${filters.inspectedOn}`

	if (filters.requestedOn != null) url += `&requestedOn=${filters.requestedOn}`

	if (filters.status != '' && filters.status != null) url += `&status=${filters.status}`
	try {
		const result = await getAll<FilteredRequestsResponse>(url)
		return result.data
	} catch {
		return { totalRequestsCount: 1, inspectionRequests: [] } as FilteredRequestsResponse
	}
}

const getAssigneesRequesters = async () => {
	try {
		const result = await getAll<RequestsWorkerResponse>(`/Requests/Workers`)
		return result.data
	} catch (err) {
		return { assignees: [], requesters: [] } as RequestsWorkerResponse
	}
}

const reassignRequest = async (requestId: number, toQCId: number, assignAll: boolean) => {
	const result = await patch(`/Requests/${requestId}?assignAll=${assignAll}`, {toQCId})
	return result.success
}


const getForemanQC = async () => {
	try {
		const result = await getAll<ForemanQC[]>(`/Requests/Foreman`)
		return result.data
	} catch (err) {
		return []
	}
}

const updateForemanQC = async (foremanId:number, toQCId: number) => {
	const result = await put(`/Requests/Foreman?foreman=${foremanId}&toQC=${toQCId}`, {})
	return result.success
}
export {
	updateForemanQC,
	getQcInspectionRequests,
	updateInspectionRequest,
	getFilteredRequests,
	getAssigneesRequesters,
	reassignRequest,
	getForemanQC
}
